import { Timer } from "lucide-react";
import { BaseEntryValue } from "./BaseEntryValue";
import type { BaseEntryValueProps } from "./BaseEntryValue";
import { EntryValueChip } from "./EntryValueChip";

export interface DurationEntryValueProps extends Omit<BaseEntryValueProps, "value"> {
    value: number | null;
    durationTimeUnit?: string;
}

export function DurationEntryValue({ value, inputLabel, durationTimeUnit, size, ...props }: DurationEntryValueProps) {
    const hasValue = value !== null && value !== undefined && `${value}` !== "";
    return (
        <BaseEntryValue inputLabel={inputLabel} size={size} {...props}>
            <EntryValueChip icon={hasValue ? Timer : undefined} size={size}>
                {hasValue ? value : "None"}
                {hasValue && durationTimeUnit && (
                    <span className="font-normal text-slate-500 text-sm dark:text-slate-400">{durationTimeUnit}</span>
                )}
            </EntryValueChip>
        </BaseEntryValue>
    );
}
